
import { DeepAnalysisResult } from '@/types/analysisTypes';
import { 
  isNewBonusFormat,
  isNewFormatExpertInsight 
} from '@/utils/bonus-section';

/**
 * Log analysis result for debugging
 */
export const logAnalysisResult = (result: DeepAnalysisResult) => {
  console.log('Analysis result:', {
    overall_score: result.overall_score,
    category_scores: result.category_scores,
    error: result.error
  });
  
  // Log bonus section format for debugging
  if (result.bonus_section) {
    console.log('Bonus section format:', 
      isNewBonusFormat(result.bonus_section) ? 'New format' : 'Legacy format');
    
    // Check for key arrays with proper type checks
    if (result.bonus_section.expert_insight) {
      if (isNewFormatExpertInsight(result.bonus_section.expert_insight)) {
        console.log('Expert insight key_takeaways:', 
          Array.isArray(result.bonus_section.expert_insight.key_takeaways) ? 
          `Array with ${result.bonus_section.expert_insight.key_takeaways.length} items` : 
          'Not an array');
      }
    }
  }
};
